module.exports = __webpack_public_path__ + "img/berkley-.18995414.jpg";